export const getWorker = () => {
  // The production worker filename uses its own content hash, which is not
  // necessarily the same as the BUILD_HASH available inside the app bundle.
  // HtmlWebpackPlugin injects the exact worker entry URL into the document, so
  // prefer that URL in both production and development builds.
  try {
    const workerScripts = document.querySelectorAll('script[src*="worker."]');
    if (workerScripts.length > 0) {
      const workerSrc = (workerScripts[0] as HTMLScriptElement).src;
      const workerPath = new URL(workerSrc).pathname;
      return new Worker(workerPath);
    }
  } catch (error) {
    console.warn('Could not find worker script in DOM:', error);
  }

  // Retain compatibility with older builds where the worker used BUILD_HASH.
  if (typeof BUILD_HASH !== 'undefined') {
    return new Worker(`/worker.${BUILD_HASH}.js`);
  }

  return new Worker(`/worker.js`);
};
